import React, { useRef, useEffect, useState } from "react";

export default function ComponentPreview({ code, widgetData, hasCompiled }) {
  const iframeRef = useRef();
  const [error, setError] = useState(null);
  const [isIframeReady, setIsIframeReady] = useState(false);

  // AST check function
  function checkCodeSafety(code) {
    if (!window.Babel || !window.Babel.transform) {
      return ["Babel.transform not loaded, cannot check code safety."];
    }

    let ast;
    try {
      const result = window.Babel.transform(code, {
        presets: [
          [
            "env",
            {
              targets: {
                browsers: ["last 2 versions"],
              },
              modules: false,
            },
          ],
          "react",
        ],
        ast: true,
      });
      ast = result.ast;
    } catch (e) {
      return ["Syntax error: " + e.message];
    }
    const allowedImports = ["react", "@mui/material"];
    let errors = [];
    function walk(node) {
      if (!node) return;
      if (node.type === "ImportDeclaration") {
        if (!allowedImports.includes(node.source.value)) {
          errors.push(`Import not allowed: ${node.source.value}`);
        }
      }
      if (
        node.type === "Identifier" &&
        [
          "window",
          "document",
          "localStorage",
          "fetch",
          "XMLHttpRequest",
        ].includes(node.name)
      ) {
        errors.push(`Usage not allowed: ${node.name}`);
      }
      for (let key in node) {
        if (node[key] && typeof node[key] === "object") {
          if (Array.isArray(node[key])) {
            node[key].forEach(walk);
          } else {
            walk(node[key]);
          }
        }
      }
    }
    walk(ast);
    return errors;
  }

  useEffect(() => {
    if (!hasCompiled) return;
    setError(null);
    if (code) {
      const errors = checkCodeSafety(code);
      if (errors && errors.length > 0) {
        setError(errors.join("; "));
        return;
      }
    }
    if (iframeRef.current && code && isIframeReady) {
      try {
        iframeRef.current.contentWindow.postMessage(
          { type: "render", code, props: { widget: widgetData } },
          "*",
        );
      } catch (e) {
        setError("Failed to send code to preview: " + e.message);
      }
    }
  }, [code, isIframeReady, hasCompiled]);

  useEffect(() => {
    function handleMessage(event) {
      if (event.data.type === "error") {
        setError(event.data.error);
      } else if (event.data.type === "ready") {
        setIsIframeReady(true);
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div>
      {error && (
        <div style={{ color: "red" }}>Compile/Runtime Error: {error}</div>
      )}
      {code ? (
        hasCompiled ? (
          <iframe
            ref={iframeRef}
            title="Component Preview"
            sandbox="allow-scripts"
            src="/component-sandbox.html"
            style={{ width: 500, height: 400, border: "1px solid #ccc" }}
          />
        ) : (
          <div style={{ padding: 40, textAlign: "center", color: "#888" }}>
            Please enter the Widget properties and click the Compile button
          </div>
        )
      ) : (
        <div style={{ padding: 40, textAlign: "center", color: "#888" }}>
          Please enter component code
        </div>
      )}
    </div>
  );
}
